import { createSlice } from '@reduxjs/toolkit';
import { RolesListStateType } from 'src/types/rolesList';

const initialState: RolesListStateType = {
    data: null,
    loading: false,
    error: false,
};
export const rolesListSlice = createSlice({
    name: 'rolesList',
    initialState,
    reducers: {
        getRolesListFetch: (state) => {
            state.loading = true;
            state.error = false;
        },
        getRolesListFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getRolesListFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
    },
});

export const { getRolesListFetch, getRolesListFetchSuccess, getRolesListFetchFailure } = rolesListSlice.actions;

export default rolesListSlice.reducer;
